type App = { mixin: (arg0: { created(): void }) => void; config: { globalProperties: { $io: string[] | Record<string, unknown> } } }
type Options = { socket: { options: Record<string, unknown> } }
type ioType = (arg0: Record<string, unknown>) => never

export interface Vue {
  io: ioType
}

export class Vue {
  install(app: App, options: Options): void {
    app.mixin({
      created() {
        // console.log('mixin hook called')
      }
    })
    if (options && options.socket) {
      const socket = {}
      const sockets = []
      if (Array.isArray(options.socket)) {
        let i = 0
        while (i < options.socket.length) {
          const obj = options.socket[i]
          sockets.push(this.io(obj.options))
          i++
        }
      } else {
        Object.assign(socket, this.io(options.socket.options))
      }
      sockets.length > 0 ? app.config.globalProperties.$io = sockets :
        app.config.globalProperties.$io = socket
    }
    if (options === undefined || {} || null) {
      app.config.globalProperties.$io = this.io(options)
    }
  }
}